
//************************************************************************************************************
function splide_play_video_popup( slide ){
  GLightbox({
    elements: [{
        'href': slide['slide']['dataset']['splideHtmlVideo'],
        'type': 'video',
        'title': slide['slide']['dataset']['splideHtmlTitle'],
        'description': slide['slide']['dataset']['splideHtmlDescription'],      
        'maxHeight': '600px', // or '80vh'
        'maxWidth': '0vw', // or '80vh'
        'zoomable': false, // Disable zoom option
    }],
      // Set width and height
      width: '900px', // or '90vw'
      height: '80vh', // or '80vh'
      videosWidth: '80vh',
      innerWidth: '100%',
      responsive: {
          768: {
              width: 'auto',
              height: '600px'
          },
          480: {
              //width: '100vw',
              //height: 'auto'
          }
      }              
  }).open();
}
//************************************************************************************************************
function splide_display_img_popup( slide ){
  $("#gallery-title").html( slide['slide']['dataset']['splideHtmlTitle'] )
  $("#gallery-description").html( slide['slide']['dataset']['splideHtmlDescription'] )
  GLightbox({
    width: '90vw', // Restrict width to 90% of the viewport
    height: '80vh', // Restrict height to 80% of the viewport      
    elements: [{
        'href':slide['slide']['dataset']['splideHtmlImg'],
        'type': 'image',
        'title': slide['slide']['dataset']['splideHtmlTitle'],
        'description': slide['slide']['dataset']['splideHtmlDescription'],
        'zoomable': false, // Disable zoom option
        'maxHeight': '80vh', // or '80vh'
        'maxWidth': '80vw', // or '80vh'
    }],
    touchNavigation: true,
    loop: true
  }).open();      
  
}
//************************************************************************************************************
function display_titles_descriptions( $slider, $index, $pre ){

   var slide = $slider.Components.Slides.getAt($index)

    console.log( 'Index: ' + $index )
  
   $( "#gallery-title-"+$pre ).html( slide['slide']['dataset']['splideHtmlTitle'] );
   $( "#gallery-description-"+$pre ).html( slide['slide']['dataset']['splideHtmlDescription'] );
  
}